// bao migrate skip 
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoSearchDialog from "./../../factories/bao-search-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../../bindings/bao-number-box";
function ConfigurationItemQualificationCustomerAssignmentViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.QualificationCustomerAssignmentTabCollection = ko.observableArray([]);
    self.QualificationCustomerAssignmentTabPageIndex = ko.observable(0);
    self.QualificationCustomerAssignmentTabPageIndex.subscribe(function () {
        self.RefreshQualificationCustomerAssignmentGrid();
    });
    self.QualificationCustomerAssignmentTabPageSize = ko.observable(10);
    self.QualificationCustomerAssignmentTabTotalRows = ko.observable(0);
    self.QualificationCustomerAssignmentTabSorting = ko.observableArray();
    self.QualificationCustomerAssignmentTabSorting.subscribe(function () {
        self.RefreshQualificationCustomerAssignmentTabGrid();
    });
    self.SelectedQualificationCustomerAssignmentTabRow = ko.observable();
    self.SelectedQualificationCustomerAssignmentTabRow.subscribe(function () {
        self.ToggleQualificationCustomerAssignmentTabToolbarButtons();
    });
    self.QualificationCustomerAssignmentTabToolbarButtons = ko.observableArray();
    self.QualificationCustomerAssignmentTabToolbarButtons.subscribe(function () {
        self.ToggleQualificationCustomerAssignmentTabToolbarButtons();
    });
    self.ToggleQualificationCustomerAssignmentTabToolbarButtons = function () {
        ko.utils.arrayForEach(self.QualificationCustomerAssignmentTabToolbarButtons(), function (button: any) {
            if (button.ActionKey() != "ConfigurationItemQualificationCustomerAssignmentTabNew") {
                button.Enabled(self.SelectedQualificationCustomerAssignmentTabRow() != null);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageQualificationCustomerAssignmentTab = Bao.Session.GetMessage("msgDeleteQualificationCustomerAssignmentTab");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemQualificationCustomerAssignmentTabNew":
                self.ShowQualificationCustomerAssignmentTabDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "ConfigurationItemQualificationCustomerAssignmentTabDelete":
                if (self.SelectedQualificationCustomerAssignmentTabRow() != null) {
                    var selectedData = self.SelectedQualificationCustomerAssignmentTabRow();
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageQualificationCustomerAssignmentTab, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.Delete(selectedData);
                        }
                    });
                }
                break;
            case "ConfigurationItemQualificationCustomerAssignmentTabEdit":
                if (self.SelectedQualificationCustomerAssignmentTabRow() != null) {
                    self.ShowQualificationCustomerAssignmentTabDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedQualificationCustomerAssignmentTabRow().ConfigurationItem200QualificationId);
                }
                break;
        }
    };
    self.EditQualificationCustomerAssignmentTab = function (item) {
        self.ShowQualificationCustomerAssignmentTabDialog(self.ConfigurationItem.ConfigurationItemId(), item.ConfigurationItem200QualificationId);
    };
    self.Delete = function (selectedData) {
        Bao.post("ConfigurationItemTab/DeleteConfigurationItemQualificationCustomerAssignment", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: selectedData.ConfigurationItemId,
            configurationItem200QualificationId: selectedData.ConfigurationItem200QualificationId
        }), function (value) {
            self.RefreshQualificationCustomerAssignmentTabGrid();
        });
    };
    self.RefreshQualificationCustomerAssignmentTabGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemQualificationCustomerAssignmentCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.QualificationCustomerAssignmentTabPageIndex(),
            pageSize: self.QualificationCustomerAssignmentTabPageSize(),
            sorting: self.QualificationCustomerAssignmentTabSorting()
        }), function (searchResult) {
            self.SelectedQualificationCustomerAssignmentTabRow(null);
            self.QualificationCustomerAssignmentTabTotalRows(0);
            self.QualificationCustomerAssignmentTabCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.QualificationCustomerAssignmentTabCollection(searchResult.Models);
                self.QualificationCustomerAssignmentTabTotalRows(searchResult.TotalRows);
                self.ToggleQualificationCustomerAssignmentTabToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("600px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                if (self.Dialog.ViewModel().CompleteCheck() == true) {
                    self.AddQualificationCustomerAssignmentTab(self.Dialog.ViewModel(), self.ConfigurationItem.ConfigurationItemId());
                    self.Dialog.Close();
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowQualificationCustomerAssignmentTabDialog = function (configurationItemId, configurationItem200QualificationId) {
        Bao.post("ConfigurationItemTab/ShowConfigurationItemQualificationCustomerAssignmentTabDialog", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: ko.unwrap(configurationItemId),
            configurationItem200QualificationId: ko.unwrap(configurationItem200QualificationId)
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            self.Dialog.ViewModel().CompleteCheck = function () {
                var isComplete = true;
                var sameQualificationId = false;
                if (self.Dialog.ViewModel().QualificationName() == null) {
                    isComplete = false;
                }
                else {
                    Bao.post("ConfigurationItemTab/IsAddQualificationAllowed", JSON.stringify({
                        sessionTabId: self.ConfigurationItem.SessionTabId(),
                        configurationItemQualificationModel: ko.map.toJS(self.Dialog.ViewModel())
                    }), function (value) {
                        if (value.value == false) {
                            isComplete = false;
                            sameQualificationId = true;
                        }
                    });
                }
                if (isComplete == false) {
                    if (sameQualificationId == false) {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                    }
                    else {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSameQualificationIdIsNotAllowed"), "info");
                    }
                }
                return isComplete;
            };
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.AddQualificationCustomerAssignmentTab = function (model, configurationItemId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemQualificationCustomerAssignment", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemQualificationModel: ko.map.toJS(model),
            configurationItemId: configurationItemId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshQualificationCustomerAssignmentTabGrid();
        });
    };
    self.Save = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/SaveConfigurationItemQualificationCustomerAssignment", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.Refresh = function () {
        self.RefreshQualificationCustomerAssignmentTabGrid();
    };
    self.loaded = function () {
        return self.Refresh();
        self.RefreshQualificationCustomerAssignmentTabGrid();
    };
}
;
export default ConfigurationItemQualificationCustomerAssignmentViewModel;